import { LitElement, html, css } from 'lit-element';
import { Theme } from '@furo/framework/src/theme';
import { FBP } from '@furo/fbp';
import '../../project-components/show-date.js';

/**
 * `display-arbeitsausgaben`
 * todo Describe your element
 *
 * @summary todo shortdescription
 * @customElement
 * @demo demo/display-arbeitsausgaben.html
 * @appliesMixin FBP
 */
class TrArbeitsausgaben extends FBP(LitElement) {
  constructor() {
    super();
    this.fields = {};
  }

  /**
   *
   * @param fieldNode
   */
  bindData(fieldNode) {
    this.fields = fieldNode;

    /*
    if (this.fields.menge._value == null) {
      this.fields.menge._value = 0;
    }
     */

    /*
    if (this.fields.text._value == null) {
      this.fields.text._value = '';
    }
     */

    fieldNode.addEventListener('field-value-changed', () => {
      this.requestUpdate();
    });
    this._FBPTriggerWire('--data', fieldNode);
    this.requestUpdate();
  }

  /**
   * Themable Styles
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return (
      Theme.getThemeForComponent(this.name) ||
      css`
        :host {
          display: table-row;
        }

        :host([hidden]) {
          display: none;
        }
      `
    );
  }

  /**
   * @private
   * @returns {TemplateResult}
   */
  render() {
    // language=HTML
    return html`
      <td><show-date ƒ-bind-data="--data(*.tag)"></show-date></td>
      <td>${this.fields.menge}</td>
      <td>${this.fields.text}</td>
      <td>${this.fields.display_objecttext}</td>
      <td>${this.fields.display_user}</td>
    `;
  }
}

window.customElements.define('tr-arbeitsausgaben', TrArbeitsausgaben);
